import { irregular, uncountable } from '@warp-drive/utilities/string';

// WarpDrive keeps its own inflection tables. The store, utils/inflector and the
// pluralize and singularize helpers all use these rules.

irregular('person', 'people');

// I know that 'medium' is the singular of 'media', but we want the API to be /media...
uncountable('media');

// Meet Ember Inspector's expectation of an export
export default {};
